/** Campos fixos da aba "Informações adicionais" (colunas no contato). */
export const ADDITIONAL_INFO_CORE_FIELDS = ["situacao", "canal", "regiao"];

/** Legado: colunas texto; selects dinâmicos usam customDynamicFields. */
export const ADDITIONAL_INFO_LEGACY_FIELDS = ["campanha", "produto"];

export const ADDITIONAL_INFO_FIELDS = [
  ...ADDITIONAL_INFO_CORE_FIELDS,
  ...ADDITIONAL_INFO_LEGACY_FIELDS,
];

const hasValue = (v) => {
  if (v === null || v === undefined) return false;
  if (Array.isArray(v)) return v.length > 0 && v.some((x) => String(x).trim() !== "");
  return String(v).trim() !== "";
};

const dynamicFieldFilled = (contact, param) => {
  const raw = contact?.customDynamicFields;
  if (!raw) return false;
  let map;
  try {
    map = typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return false;
  }
  return hasValue(map?.[param]);
};

/** Todos os campos obrigatórios preenchidos → bolinha verde na lista. */
export const isContactAdditionalInfoComplete = (contact) => {
  if (!contact) return false;

  const coreOk = ADDITIONAL_INFO_CORE_FIELDS.every((field) =>
    hasValue(contact[field])
  );
  if (!coreOk) return false;

  const campanhaOk =
    hasValue(contact.campanha) || dynamicFieldFilled(contact, "CAMPANHAS");
  const produtoOk =
    hasValue(contact.produto) ||
    dynamicFieldFilled(contact, "PRODUTOS") ||
    dynamicFieldFilled(contact, "PRODUTO");

  return campanhaOk && produtoOk;
};
